import React from "react";
import { ClassCardProps } from "./class-card.props";
import classMap from "../../helpers/classMap";
import OverflowTooltip from "../overflow-tooltip/overflow-tooltip";
import "./class-card.scss";

const ClassCard = (props: ClassCardProps) => {
  const { title, subjects = [], teachers, onClick, mpngStyle, className } = props;

  return (
    <button
      className={classMap("class-card", className, mpngStyle ? "mpng-style" : "")}
      onClick={() => (onClick ? onClick() : {})}
      disabled={!onClick}
    >
      {title}
      {/*add subjects here for use in educator ui*/}
      <OverflowTooltip help={teachers}>
        <p className="teachers">
          <span>Teacher: </span>
          {teachers}
        </p>
      </OverflowTooltip>
    </button>
  );
};

export default ClassCard;
